// extracted by mini-css-extract-plugin
export var mobileHeader = "Layout-module--mobileHeader--1A7lT";
export var desktopHeader = "Layout-module--desktopHeader--1ENKn";